import $ from 'jquery';
import pageScripts from './pages';

require('what-input');
var objectFitImages = require('object-fit-images');

$(document).ready(function () {
	//Require all components here.
	require('./components/foundation');
	require('./components/slider');
	require('./components/facet-wp');
	require('./components/social-share');
	require('./components/toggle-menu');
	require('./components/toggle-tabs');
	require('./components/fp');
	require('./components/check-container-children');

	objectFitImages();

	document.body.className.replace(/-/g, '_').split(/\s+/).forEach(cls => {
		pageScripts[cls] && pageScripts[cls]();
	});
});
